import React from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { WarningQA } from '../shared/components/WarningQA';
import { Layout } from '../shared/containers/Layout';
import AppRouter from './AppRouter';

export const Principal = () => {
    return (
        <Router>
              {
                process.env.REACT_APP_MODE ==="qa" && 
                (
                  <WarningQA />
                )
              }
            <Layout>
              <Switch>
                <Route path="/:u" component={(props) => <AppRouter {...props}/>} />      
                <Redirect to="/caps/" />
              </Switch>
            </Layout>
        </Router>
      );
}
